import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { LlmSettingService } from 'src/app/_services/llm-setting.service';
import { LlmModelsModalComponent } from '../llm-models-modal/llm-models-modal.component';
import { Global } from 'src/app/_services/global.service';

@Component({
  selector: 'app-llm-setting-item',
  templateUrl: './llm-setting-item.component.html',
  styleUrls: ['./llm-setting-item.component.scss']
})
export class LlmSettingItemComponent implements OnInit {
  formGroup: FormGroup;
  isEditMode: boolean = false;
  @Input() orgData: any;
  updatedFlag: boolean;
  
  modelProviders = this.global.section.LlmModelProviderTypeSelections;

  constructor(
    private fb: FormBuilder,
    private modalRef: NzModalRef,
    private llmSettingService: LlmSettingService,
    private nzModalService: NzModalService,
    private global: Global
  ) { }

  ngOnInit(): void {
    this.isEditMode = !!this.orgData;
    this.initForm();

    if (this.isEditMode) {
      this.patchFormData(this.orgData);
    }
  }

  initForm() {
    this.formGroup = this.fb.group({
      modelProvider: ['', Validators.required],
      modelId: ['', Validators.required],
      apiEndpoint: ['', Validators.required],
      apiKey: ['', Validators.required],
    });
  }

  patchFormData(orgData: any) {
    if (!orgData) return;

    this.formGroup.patchValue({
      modelProvider: orgData.modelProvider || '',
      modelId: orgData.modelId || '',
      apiEndpoint: orgData.apiEndpoint || '',
      apiKey: orgData.apiKey || '',
    });
  }

  checkValidation() {
    if (this.formGroup.valid) {
      const formValue = this.formGroup.value;
      this.onSubmit(formValue, this.orgData?.id);
    } else {
      this.markFormGroupTouched(this.formGroup);
    }
  }

  onSubmit(formValue: any, id?: string) {
    if (id) {
      this.llmSettingService.updateLlmSetting(formValue, id).subscribe((res) => {
        this.modalRef.close(res);
      });
    } else {
      this.llmSettingService.createLlmSetting(formValue).subscribe((res) => {
        this.modalRef.close(res);
      });
    }
  }

  markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      control?.markAsTouched();
    });
  }

  cancel() {
    this.modalRef.close();
  }

  previousModelProvider: string = '';

  onModelProviderChange(newProvider: string) {
    // 如果新选择的 Provider 与之前的不同，则清空其他字段
    if (newProvider !== this.previousModelProvider) {
      // 清空 Model ID、API Endpoint 等字段
      this.formGroup.patchValue({
        modelId: '',
        apiEndpoint: '',
        apiKey: ''
        // 注意：不包括 apiKey，因为 apiKey 通常是独立的
      });
    }
    // 更新之前的 Provider 值
    this.previousModelProvider = newProvider;
  }

  openModelsModal() {
    const modelProvider = this.formGroup.get('modelProvider')?.value;

    if (!modelProvider) {
      this.nzModalService.warning({
        nzTitle: 'Warning',
        nzContent: 'Please select a Model Provider first'
      });
      return;
    }

    const modal = this.nzModalService.create({
      nzTitle: `${modelProvider} Available Models`,
      nzContent: LlmModelsModalComponent,
      nzComponentParams: {
        providerType: modelProvider
      },
      nzWidth: 800,
      nzFooter: null
    });

    modal.afterClose.subscribe((result: any) => {
      if (result) {
        this.formGroup.patchValue({
          modelProvider: result.providerName,
          apiEndpoint: result.apiEndpoint,
          modelId: result.modelId
        });
      }
    });
  }
}